import { useQuery } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';
import { useQuery as useQueryParams } from 'components/hooks/useQuery';
import { useSelectedView } from 'reducers/viewsSlice';

import { endpoints } from 'constants/endpoints';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

type ColumnDef = {
  id: string;
  displayName: string;
  field: string;
};

export const getReviewsDetailedReportsApi = ({
  cohortId,
  reviewCycleId,
  limit = 1000,
  pivotMode = false,
  rowGroupCols = [],
  pivotCols,
}: {
  cohortId: number;
  reviewCycleId: number | null;
  limit?: number;
  pivotMode?: boolean;
  rowGroupCols?: ColumnDef[];
  pivotCols?: ColumnDef[];
}) => {
  const url = endpoints.performanceReview.insights.generateReport;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      reportType: 'DETAILED_REVIEW',
      cohortId,
      limit,
      baseFilter: {
        reviewCycleId,
      },
      pivotMode,
      rowGroupCols,
      pivotCols,
    },
  });
};

export const useGetReviewsDetailedReport = () => {
  const cohort = useSelectedView();
  const rawReviewCycleId = useQueryParams().reviewCycleId;
  const reviewCycleId = rawReviewCycleId ? Number(rawReviewCycleId) : null;

  return useQuery(
    [REACT_QUERY_KEYS.reviewGenerateReport, cohort?.id, reviewCycleId],
    () =>
      getReviewsDetailedReportsApi({
        cohortId: cohort?.id,
        reviewCycleId,
      }).then((res) => {
        const { entity } = res;

        return entity;
      }),
    {
      enabled: cohort?.id !== undefined && !!reviewCycleId,
    }
  );
};
